'use client';
import { analiticaInstance } from '@payments-checkout/shared/plugins/analitica/analitica.events';
import { resolveScreenFromPathname } from '@payments-checkout/shared/plugins/analitica/analitica.helpers';
import {
  ActionButton,
  DropdownMenu,
  DropdownMenuItem,
} from '@stone-payments/jade';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { HeaderContainer, HeaderContent } from './header.styles';

import { translationMessages } from '@payments-checkout/shared/helpers/translations/messages.helper';
import { useTranslationProvider } from '../../app/providers/translationProvider';
import { HeaderLogo } from './headerLogo';

type translationMessagesType = keyof typeof translationMessages;

export function Header() {
  const { handleChange, currentLocale } = useTranslationProvider();
  const pathname = usePathname();

  const allLanguages: { label: string; key: translationMessagesType }[] = [
    { label: '🇺🇸 English', key: 'en' },
    { label: '🇧🇷 Português', key: 'pt' },
  ];

  const [language, setLanguage] = useState(getInitialLanguage());
  const [languages, setLanguages] = useState(getLanguages());

  function getInitialLanguage() {
    return allLanguages.find((language) => language.key === currentLocale);
  }

  function getLanguages() {
    return allLanguages.filter((language) => language.key !== currentLocale);
  }

  function changeLanguage(languageParam: {
    label: string;
    key: translationMessagesType;
  }) {
    handleChange(languageParam.key);
    languages.push(language!);
    setLanguage(languageParam);
    setLanguages(
      languages.filter((language) => language.label !== languageParam.label)
    );
  }

  function languageItem(language: {
    label: string;
    key: translationMessagesType;
  }) {
    return (
      <DropdownMenuItem
        key={language.key}
        onClick={() => {
          changeLanguage(language);
          const languageAnaliticaLabel = language.key === 'en' ? 'ingles' : 'portugues'
          analiticaInstance.events.homePage.languageSelected(
            resolveScreenFromPathname(pathname),
            languageAnaliticaLabel
          );
        }}
        label={language.label}
      />
    );
  }

  return (
    <HeaderContainer>
      <HeaderContent>
        <HeaderLogo />
        <div>
          <DropdownMenu
            trigger={
              <ActionButton
                dropdownIndicator
                data-testid="dropdown-language-menu-button"
              >
                {language?.label}
              </ActionButton>
            }
          >
            {languages.map(languageItem)}
          </DropdownMenu>
        </div>
      </HeaderContent>
    </HeaderContainer>
  );
}
